import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const RenderOnWebCaptureComposition = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(241 / 30) * fps}
			style={{
				width: 1596,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/render-on-web-2026-09-23-15-10.mp4"
				muted
				durationInFrames={(241 / 30) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[1, 55, 56, 57, 84, 93, 116],
					['auto', 'row-resize', 'auto', 'default', 'auto', 'default', 'auto'],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 22, 25, 68, 73, 105, 109, 172, 176],
						[
							2.424019253277923, 2.1816173279501307, 2.424019253277923,
							2.1816173279501307, 2.424019253277923, 2.1816173279501307,
							2.424019253277923, 2.1816173279501307, 2.424019253277923,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 27,
							28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
							44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
							60, 61, 62, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95,
							96, 97, 115, 116, 141, 142, 143, 144, 145, 146, 147, 148, 149,
							150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162,
							163, 164, 165, 166, 167, 168, 169, 170,
						],
						[
							'263.8582832493852px 1438.627020344823px',
							'267.83518983679426px 1437.5381054458894px',
							'279.1314983100777px 1434.5933008061652px',
							'345.05345940898746px 1411.9533397335576px',
							'564.3987953550152px 1358.1988190270781px',
							'1058.860847722879px 1262.4216520469759px',
							'1321.8479990531173px 1234.6306500611527px',
							'1383.859335341075px 1230.4548981443731px',
							'1383.7457094385775px 1230.4548981443731px',
							'1372.4209944896697px 1240.8516682228856px',
							'1353.1045910651112px 1259.8934757164086px',
							'1311.3944160233564px 1281.8327437236155px',
							'1251.8828495903417px 1304.3306724181011px',
							'1207.9380317994712px 1317.2366811767645px',
							'1193.1856021252252px 1318.335064900906px',
							'1187.9682794355526px 1318.9316008890173px',
							'1185.2223201251988px 1318.9316008890173px',
							'1185.1844448243664px 1318.9316008890173px',
							'1185.1844448243664px 1318.9316008890173px',
							'1186.1692026460105px 1317.5775588842566px',
							'1188.555346598456px 1314.433908915162px',
							'1193.5643551335497px 1307.0292876024146px',
							'1197.7779823511619px 1302.285406173148px',
							'1206.1768303107615px 1291.775010192138px',
							'1209.1784479017344px 1285.288864924578px',
							'1211.2805270979366px 1279.8442904299109px',
							'1215.1722142584726px 1271.4549112955194px',
							'1220.8345717329264px 1261.304330672418px',
							'1229.5648285748102px 1249.1463591051959px',
							'1249.1368902799877px 1222.8987756282959px',
							'1274.011494101711px 1188.4038453951262px',
							'1297.2195846868053px 1154.9031418088086px',
							'1324.3667065584764px 1114.2534751903627px',
							'1356.645931692947px 1067.4301345362248px',
							'1389.2755033601177px 1022.6236536514157px',
							'1405.8080721734898px 1001.0631386525336px',
							'1431.0424913531212px 966.8333355251909px',
							'1451.6939991320241px 934.2511079840607px',
							'1467.6679072581173px 905.0587198674364px',
							'1481.8143321190441px 881.4150633227686px',
							'1495.2790015649862px 853.8797196175647px',
							'1505.8462104972448px 834.0993437578085px',
							'1517.218269572193px 816.1653888136351px',
							'1528.552453346309px 797.7201173082234px',
							'1538.845066347532px 781.4337379502623px',
							'1547.1397572298424px 763.1399676481805px',
							'1550.103499519983px 752.648509317587px',
							'1550.9556937887137px 743.1039335078052px',
							'1551.561698602033px 735.8129380975552px',
							'1551.8552321834848px 729.071134549376px',
							'1552.1014216388958px 722.6986151843132px',
							'1552.28132931785px 718.8448033246096px',
							'1552.28132931785px 716.6575047015347px',
							'1552.28132931785px 716.1745946159207px',
							'1552.28132931785px 716.1745946159207px',
							'1547.0450689777613px 715.3981509488551px',
							'1544.270703191783px 713.4096976551506px',
							'1534.7640026828337px 705.6357921592867px',
							'1528.6755480740146px 698.8277068346506px',
							'1522.8995646970632px 691.3568037454463px',
							'1515.580162811189px 681.5376320046291px',
							'1511.0067202356684px 673.3565670248162px',
							'1508.6963268848879px 668.6505608963821px',
							'1506.6510606399347px 661.3027525348833px',
							'1505.1076421310115px 655.195360275648px',
							'1501.992398637541px 647.2131406252055px',
							'1499.7577558884257px 641.7117531792895px',
							'1498.4037138836648px 638.1609437262457px',
							'1497.9113349728427px 637.2045923802259px',
							'1497.9113349728427px 637.2045923802259px',
							'1497.9113349728427px 637.5549389129262px',
							'1497.9113349728427px 637.5549389129262px',
							'1493.8302713081443px 639.9978958166204px',
							'1462.7914622759372px 659.2196109890976px',
							'1312.6443009508278px 766.7191835768486px',
							'1154.0982916661187px 893.1658754060416px',
							'1028.721577085443px 987.7783768855455px',
							'909.2628782598402px 1071.0377569405173px',
							'768.3288838622285px 1169.4188508528518px',
							'675.5628032983074px 1234.8484330409394px',
							'626.7415405252567px 1268.8509843632871px',
							'587.3417588342824px 1292.2863267533764px',
							'544.3911676902642px 1314.4717842159944px',
							'500.9955417614645px 1334.1574718236693px',
							'471.15927353068815px 1352.1008955930508px',
							'442.7054537802969px 1371.388892541985px',
							'409.4509396493904px 1390.8946724707057px',
							'388.23130235800045px 1399.4450216336352px',
							'365.9416878180933px 1403.5450229487499px',
							'353.79318507607934px 1405.0410973316323px',
							'340.06338852430986px 1405.173660884546px',
							'329.58139901892446px 1408.7244703375898px',
							'318.8816265337524px 1416.0249345730479px',
							'310.85206275726927px 1423.5999947395414px',
							'307.06453267402253px 1428.0787490629807px',
							'302.8414366312024px 1431.0898354791618px',
							'294.9728428832573px 1435.8337169084284px',
							'286.3562119438709px 1439.517089914386px',
							'282.47399360854297px 1440.7101618906086px',
							'280.7033232946251px 1441.4108549560094px',
							'280.49500914004653px 1441.5244808585066px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
